import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import PageLayout from '../../components/layout/PageLayout';
import { AccountBoundary, useRequestScope } from '../settings/shared';
import { authApi } from '../../api/auth';
import { authReturnPath, validateLoginUser } from '../auth/model';
import { acceptLogin } from '../auth/session';
import { useSignupStyle, useCleanCallbackUrl } from './shared';
import '../password/Password.css';
export default function OAuthReturn() {
  const location = useLocation();
  return <AccountBoundary key={location.key} component={Callback} />;
}
function Callback({ user }) {
  const location = useLocation(),
    nav = useNavigate(),
    { style, t } = useSignupStyle(),
    request = useRequestScope(user);
  const [params] = useState(() => new URLSearchParams(location.search)),
    [error, setError] = useState(''),
    [loading, setLoading] = useState(true);
  const target = authReturnPath(params.get('redirectUrl'));
  useCleanCallbackUrl();
  useEffect(() => {
    let active = true;
    const r = request();
    const fail = (key) => {
      if (active) {
        setLoading(false);
        setError(t(key));
      }
    };
    if (user) {
      nav(target, { replace: true });
      return () => r.cancel();
    }
    if (params.get('isActive') === 'false') {
      fail('auth.inactiveAccount');
      return () => r.cancel();
    }
    if (location.pathname.endsWith('/error') || params.has('error')) {
      fail(params.get('error') === 'cancelled' ? 'auth.socialCancelled' : 'auth.socialLoginFailed');
      if (params.get('message')) setError(params.get('message').slice(0, 400));
      return () => r.cancel();
    }
    const token = params.get('token');
    if (!token) {
      fail('auth.noLoginToken');
      return () => r.cancel();
    }
    authApi
      .getMeWithToken(token, { ...r.options, omitPageQuery: true })
      .then((result) => {
        if (!active || !r.current()) return;
        if (result?.data?.isActive === false) {
          fail('auth.inactiveAccount');
          return;
        }
        if (result?.data?.id == null) {
          fail('auth.noLoginToken');
          return;
        }
        const accepted = validateLoginUser({ ...result?.data, token }, t);
        acceptLogin(accepted);
        nav(target, { replace: true });
      })
      .catch(() => {
        if (active && r.current()) fail('auth.socialLoginFailed');
      });
    return () => {
      active = false;
      r.cancel();
    };
    // The mounted callback owns one candidate token. Language changes never replay authentication.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <PageLayout paddingTop={0} paddingBottom={0}>
      <div className="pp-settings pp-password pp-signup" style={style}>
        <header className="pp-password-reset-header">
          <h1>{t('auth.login')}</h1>
        </header>
        {loading ? (
          <p role="status">{t('auth.loggingIn')}</p>
        ) : (
          <>
            <p role="alert" className="pp-password-error">
              {error}
            </p>
            <Link
              className="pp-password-submit pp-signup-return"
              to={'/login?redirectUrl=' + encodeURIComponent(target)}
              replace
            >
              {t('auth.login')}
            </Link>
          </>
        )}
      </div>
    </PageLayout>
  );
}
